var _circle, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#E2E8EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7907 8.8939L7.69622 8.58866C7.55378 8.48692 7.47238 8.2936 7.47238 8.13081C7.47238 7.22529 9.28343 7.1032 9.28343 5.59738C9.28343 4.68169 8.5 4 7.21802 4C6.30233 4 5.5189 4.36628 5 5.00727L5.69186 5.77035C6.02762 5.33285 6.47529 5.05814 7.1061 5.05814C7.75727 5.05814 8.07267 5.3939 8.07267 5.7907C8.07267 6.65552 6.43459 6.77762 6.43459 8.0189C6.43459 8.35465 6.54651 8.65988 6.7907 8.8939ZM7.15698 11C7.5436 11 7.86919 10.6642 7.86919 10.2776C7.86919 9.90116 7.5436 9.57558 7.15698 9.57558C6.77035 9.57558 6.44477 9.90116 6.44477 10.2776C6.44477 10.6642 6.77035 11 7.15698 11Z",
    fill: "#465C6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.f5ef9d2a1dbc013004cd05d8d0ef9fb5.svg";
export { ForwardRef as ReactComponent };